export const QueryKeys = {
  // Cell Dashboard Query Keys
  CELL_DASHBOARD: 'cellDashboard',
  CELL_DASHBOARDS: 'cellDashboards',
  CELL_DASHBOARD_TEMPLATE: 'cellDashboardTemplate',
  CELL_DASHBOARD_TEMPLATES: 'cellDashboardTemplates',
  CELL_BOARD_SAFETY_METRICS: 'cellBoardSafetyMetrics',
  CELL_BOARD_SAFETY_MESSAGES: 'cellBoardSafetyMessages',
  CELL_BOARD_SAFETY_TOPICS: 'cellBoardSafetyTopics',
  CELL_BOARD_NEAR_HIT_INCIDENTS: 'cellBoardNearHitIncidents',
  CELL_BOARD_NEAR_HIT_INCIDENTS_COUNT: 'cellBoardNearHitIncidentsCount',
  CELL_BOARD_FIRST_TIME_PASS_METRICS: 'cellBoardFirstTimePassMetrics',
  CELL_BOARD_FIRST_TIME_PASS_METRICS_DATA: 'cellBoardFirstTimePassMetricsData',
  CELL_BOARD_SUMMARY: 'cellBoardSummary',
  CELL_BOARD_MESSAGE_COUNT: 'cellBoardMessageCount',
  CELL_BOARD_MESSAGE_COUNT_BULK: 'cellBoardMessageCountBulk',
  CELL_BOARD_PRODUCTION_METRIC: 'cellBoardProductionMetric',
  CELL_BOARD_PRODUCTION_METRIC_INTERVALS: 'cellBoardProductionMetricIntervals',
  CELL_BOARD_LABOR_HOURS_PER_UNIT_METRICS: 'cellBoardLaborHoursPerUnitMetrics',
  CELL_BOARD_DATA: 'cellBoardData',
  CELL_BOARD_MESSAGES_GLOBAL: 'cellBoardMessagesGlobal',
  BREAK_DISPLAY: 'breakDisplay',

  // base key
  CELL_BOARD_MESSAGES: 'cellBoardMessages',

  // dynamic keys based on inventory center, mCell, and mCellCollection
  cellBoardMessagesByLocation: (
    inventoryCenterId: string,
    mCellId: string,
    mCellCollectionId: string,
  ) =>
    [
      QueryKeys.CELL_BOARD_MESSAGES,
      inventoryCenterId,
      mCellId,
      mCellCollectionId,
    ] as const,

  // Resource Tracking Query Keys
  JOB_STATIONS: 'stations',
  JOB_STATION_ASSIGNMENTS: 'jobStationAssignments',
  CURRENT_MCELL_EMPLOYEE: 'currentMCellEmployee',
  MCELL_EMPLOYEE_BY_BADGE_ID: 'mCellEmployeeByBadgeId',
  HOME_CELL_NOTIFICATION_ENABLED_ICS: 'homeCellNotificationEnabledICs',

  // LMS Query Keys
  LMS_INTEGRATION_CONFIGS: 'lmsIntegrationConfigs',
  LMS_COURSE_CATALOGS: 'lmsCourseCatalogs',
  LMS_ASSESSMENT_STATUSES: 'lmsAssessmentStatuses',
  LMS_PREVIOUS_SAFETY_COURSE_COMPLETION_METRIC:
    'lmsPreviousSafetyCourseCompletionMetric',
  LMS_CURRENT_SAFETY_COURSE_COMPLETION_METRIC:
    'lmsCurrentSafetyCourseCompletionMetric',
  LMS_PREVIOUS_SAFETY_COURSE_COMPLETION_METRIC_DETAILED_VIEW:
    'lmsPreviousSafetyCourseCompletionMetricDetailedView',
  LMS_CURRENT_SAFETY_COURSE_COMPLETION_METRIC_DETAILED_VIEW:
    'lmsCurrentSafetyCourseCompletionMetricDetailedView',

  // MCell Query Keys
  MCELL: 'mCell',
  MCELLS: 'mCells',
  MCELL_CLONE_PREVIEW: 'mCellClonePreview',
  MCELL_COLLECTIONS: 'mCellCollections',
  MCELL_COMPLETION_CONFIGS: 'mCellCompletionConfigs',
  MCELL_SCHEDULE_TEMPLATES: 'mCellScheduleTemplates',
  MCELL_SCHEDULE_TEMPLATE: 'mCellScheduleTemplate',
  MCELL_SCHEDULES: 'mCellSchedules',
  MCELL_SCHEDULE: 'mCellSchedule',

  // MCell Employee Query Keys
  MCELL_EMPLOYEES_IN_MCELL: 'mCellEmployeesInMCell',
  MCELL_EMPLOYEES_LOGGED_IN: 'mCellEmployeesLoggedIn',
  MCELL_EMPLOYEE_SELECTION: 'mCellEmployeeSelection',
  MCELL_EMPLOYEES_LIST: 'mCellEmployeesList',
  EMPLOYEES_LIST: 'employeesList',

  PRODUCING_LOCATIONS_OPTIONS: 'producingLocations',
  PRODUCTION_LINES_OPTIONS: 'productionLines',
  WORK_CENTERS_OPTIONS: 'workCenters',
  WORK_CENTER_STATIONS_OPTIONS: 'workCenterStations',
  INVENTORY_CENTERS: 'inventoryCenters',
  USER_FEEDBACK: 'userFeedback',
  USER_FEEDBACK_CONFIG: 'userFeedbackConfigs',
  SHAREPOINT_LIBRARIES: 'sharepointLibraries',
  SHAREPOINT_COLUMNS: 'sharepointColumns',
  BREAKTIME_ANNOUNCEMENT_CONFIG: 'breaktimeAnnouncementConfig',
  BREAKTIME_ANNOUNCEMENT_CONFIG_SUMMARIES:
    'breaktimeAnnouncementConfigSummaries',

  // Coatings Query Keys
  COATINGS_BOARD_DATA: 'coatingsBoardData',

  // Support Hierarchy Query Keys
  MCELL_SUPPORT_HIERARCHY: 'mCellSupportHierarchy',

  // Taqo Query Keys
  TAQO_PRODUCING_LOCATION_MCELL_MAPPINGS: 'taqoProducingLocationMCellMappings',
  TAQO_PRODUCTION_LINE_OPTIONS: 'taqoProductionLineOptions',
  TAQO_LATEST_AUDIT: 'taqoLatestAudit',
  TAQO_RECENT_AUDITS: 'taqoRecentAudits',
};
